import { render } from "./VisitorWrapper.vue?vue&type=template&id=1185d019"
import script from "./VisitorWrapper.vue?vue&type=script&lang=js"
export * from "./VisitorWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__